import type { TOC } from '@ember/component/template-only';
import { not } from 'ember-truth-helpers';
import type Entry from 'garaje/models/entry';

interface DocumentColumnSignature {
  Args: {
    content: Entry;
    isTableCell?: boolean;
    displayDash?: boolean;
    displayNdaDownload?: boolean;
  };
  Element: HTMLDivElement;
}

export default <template>
  <div class="align-middle :text-carbon-50 :flex {{if @isTableCell 'table-cell'}}" ...attributes>
    {{#if @content.agreementRefused}}
      {{#if @displayDash}}
        <img alt="" src="/assets/images/cross-small-red.svg" role="presentation" />
      {{/if}}
      <span class="whitespace-nowrap" data-test-nda-column-status data-test-not-signed>Not Signed</span>
    {{else if @content.ndaDiscarded}}
      {{#if @displayDash}}
        <img alt="" src="/assets/images/gray-dash-small.svg" role="presentation" />&nbsp;
      {{/if}}
      <span class="whitespace-nowrap" data-test-nda-column-status data-test-discarded>
        Document discarded
      </span>
    {{else}}
      {{#if (not @content.agreementLink)}}
        {{#if @displayDash}}
          <img alt="" src="/assets/images/gray-dash-small.svg" role="presentation" />&nbsp;
        {{/if}}
        <span class="whitespace-nowrap" data-test-nda-column-status data-test-not-required>
          Not required
        </span>
      {{else if @displayNdaDownload}}
        <a
          href={{@content.agreementLink}}
          data-test-download-pdf
          target="_blank"
          rel="noopener noreferrer"
          class="downloadPdf"
          aria-label="Download PDF"
        >
          ↓ PDF
        </a>
      {{else}}
        {{#if @displayDash}}
          <img alt="" src="/assets/images/checkmark-small-gray.svg" role="presentation" />&nbsp;
        {{/if}}
        <span class="whitespace-nowrap" data-test-nda-column-status>
          {{if @content.originalNdaSignDate "NDA on file" "Signed"}}
        </span>
      {{/if}}
    {{/if}}
  </div>
</template> satisfies TOC<DocumentColumnSignature>;
